import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import styles from "@/styles/Video.module.scss";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EntitlementConfirm(_ref) {
  let {
    state
  } = _ref;
  const handleCancel = useCallback(() => {
    state.prepareReconfirm();
  }, []);
  const handleConfirm = useCallback(() => {
    state.entitlementConfirm();
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.entitlement,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.message,
      children: /*#__PURE__*/_jsxs("p", {
        children: ["\u3054\u8CFC\u5165\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002", /*#__PURE__*/_jsx("br", {}), "\u8996\u8074\u53EF\u80FD\u671F\u9593\u3092\u3054\u78BA\u8A8D\u3044\u305F\u3060\u304D\u3001\u3054\u8996\u8074\u3092\u304A\u697D\u3057\u307F\u304F\u3060\u3055\u3044\u3002"]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.buttons,
      children: [/*#__PURE__*/_jsx(ButtonMultiClick, {
        fillColor: true,
        medium: true,
        fillGray: true,
        borderGray: true,
        onClick: handleCancel,
        children: "\u30AD\u30E3\u30F3\u30BB\u30EB"
      }), /*#__PURE__*/_jsx(ButtonMultiClick, {
        fillColor: true,
        medium: true,
        onClick: handleConfirm,
        children: "\u518D\u751F\u3059\u308B"
      })]
    })]
  });
}